const formatDateToIso = (dateString: string) => {
  if (dateString && dateString.toString().includes("/")) {
    const dateArr = dateString.split("/");
    const day = dateArr[0];
    const month = dateArr[1];
    const year = dateArr[2];

    const dayStr = parseInt(day) < 10 ? `0${day}` : day;
    const monthStr =
      parseInt(month) < 10 && month.length < 2 ? `0${month}` : month;

    return `${year}-${monthStr}-${dayStr}`;
  }

  return dateString;
};

export default formatDateToIso;
